import axios from "axios";

export const axiosApi = async (
    url,
    data = {},
    method = "POST",
    headers = {}
) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios({
            url,
            method,
            data,
            headers: {
                ...(token && {
                    Authorization: `Bearer ${token}`,
                }),
                ...headers,
            },
        });

        if ([401, 403].includes(response.status) ) {
            localStorage.removeItem("token");
            window.location.href = "/";
            return;
        }

        return response;
    } catch (error) {
        if ([401, 403].includes(error.response?.status)) {
            localStorage.removeItem("token");
            window.location.href = "/";
        }

        throw error;
    }
};